module.exports = __webpack_public_path__ + "static/media/pn.250c320b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pn.svg
// module id = 961
// module chunks = 0